import AuthService from '../../AuthService';
const onlineExhibition = {
  getOnlineExhibition(page){
    return AuthService.get(`/resource_center/online_exhibition?page=${page}`);
  },
  showOnlineExhibition(id){
    return AuthService.get(`/resource_center/online_exhibition/${id}`);
  },
  createOnlineExhibition(data){
    return AuthService.post(`/resource_center/online_exhibition`,data);
  },
  updateOnlineExhibition(id,data){
    return AuthService.put(`/resource_center/online_exhibition/${id}`,data);
  },
  deleteOnlineExhibition(id){
    return AuthService.delete(`/resource_center/online_exhibition/${id}`);
  },
}
export default onlineExhibition
